import {Button} from '@wandb/components';

import styles from './ErrorState.module.css';

type ErrorStateProps = {
  title: string;
  role?: 'alert' | 'status';
};

export const ErrorState = ({title, role = 'alert'}: ErrorStateProps) => (
  <div role={role} className={styles.errorState}>
    <strong>{title}</strong>
    <span className={styles.detail}>Try reloading the page.</span>
    <Button
      size="sm"
      variant="secondary"
      onPress={() => window.location.reload()}>
      Reload
    </Button>
  </div>
);
